import React from 'react';

function Breadcrumbs({
  pageTitle = '',
  pageSubtitle = '',
  activePage = ''
}) {
  return (
    <div className="breadcrumbs sticked-header-offset">
      <div className="page-header d-flex align-items-center">
        <div className="container position-relative">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-6 col-md-7 col-sm-10 col-12 text-center">
              <h2 data-aos="fade-up" data-aos-delay="300">{pageTitle}</h2>
              <p data-aos="fade-up" data-aos-delay="400">
                {pageSubtitle}
              </p>
            </div>
          </div>
        </div>
      </div>

      <nav aria-label="breadcrumb">
        <div className="container">
          <ol className="breadcrumb" data-aos="fade-up" data-aos-delay="600">
            <li className="breadcrumb-item Home">
              <a href="/" className="breadcrumb-link">Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {activePage}
            </li>
          </ol>
        </div>
      </nav>
    </div>
  );
}

export default Breadcrumbs;
